export default __webpack_public_path__ + "images/SpeakersPhotos/Juan_Segui.jpg?0f71cccf";